import { Box } from '@chakra-ui/layout'
import { withPrefix } from 'gatsby'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import Footer from './Footer'
import Header from './Header'

/* eslint-disable-next-line */
export interface LayoutProps {
  children?: React.ReactChild
}

export function Layout(props: LayoutProps) {
  return (
    <>
      <Helmet>
        <html lang="en" />
        <title>Common Places, Common Times</title>
        <meta
          name="description"
          content="Ein Projekt des Lehrstuhls für Jüdische Geschichte und Kultur. Eine Interaktive Karte zur deutsch-jüdischen Geschichte"
        />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href={`${withPrefix('/')}img/apple-touch-icon.png`}
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-32x32.png`}
          sizes="32x32"
        />
        <link
          rel="icon"
          type="image/png"
          href={`${withPrefix('/')}img/favicon-16x16.png`}
          sizes="16x16"
        />

        <link
          rel="mask-icon"
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color="#ff4400"
        />
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="website" />
        <meta property="og:title" content="Common Places, Common Times" />
        <meta property="og:url" content="/" />
        <meta
          property="og:image"
          content={`${withPrefix('/')}assets/og-image.jpg`}
        />
      </Helmet>

      <Box display="flex" flexDirection="column" h="100vh" minH="720px">
        <Header />
        <Box flex="auto" background="gray.300">
          {props.children}
        </Box>
        <Footer />
      </Box>
    </>
  )
}

export default Layout
